import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3437fd63"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RaffleRecord" }
const _hoisted_2 = { class: "statistical" }
const _hoisted_3 = { class: "itemModal" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"16px"} }, " 是否领取当前奖励？ ", -1))
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = { class: "itemModal" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"16px"} }, " 是否一键领取“当前条件”下的所有未领取奖励？ ", -1))
const _hoisted_8 = { class: "dialog-footer" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { initEmptyParam } from '@/hooks/useInitParam'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import { postData, queryStatistical } from '@/service/main/system'
import localCache from '@/utils/cache'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RaffleRecord',
  setup(__props) {

initEmptyParam()
const router = useRouter()
const store = useStore()
const routeParam = useRoute()
console.log(routeParam)
store.state.system.queryInfo.raffleId = routeParam.query.id
store.state.system.queryInfo.uuid = routeParam.query.uuid

const getEmp = async () => {
  let userList = localCache.getCache('empData')
  const userOptions = userList.map((item: any) => {
    return { title: item.realName, value: item.id }
  })
  const userItem = searchFormConfig.formItems.find(
    (item) => item.field === 'userId'
  )
  userItem!.options = userOptions
}
getEmp()

const allReceiveDialogVisible = ref(false)
const receiveDialogVisible = ref(false)
let receivedId = ref()

const changeReceiveStatus = (row: any) => {
  receiveDialogVisible.value = true
  receivedId.value = row.id
}

const handleReceive = async (row: any) => {
  if (row) {
    await postData('/main/raffleRecord/receive', { id: receivedId.value }).then(
      (item) => {
        receiveDialogVisible.value = false
        initData()
      }
    )
  } else {
    receiveDialogVisible.value = false
  }
}

const changeAllReceiveStatus = () => {
  allReceiveDialogVisible.value = true
}

const handleAllReceive = async (row: any) => {
  if (row) {
    await postData(
      '/main/raffleRecord/allReceive',
      store.state.system.queryInfo
    ).then((item) => {
      allReceiveDialogVisible.value = false
      initData()
    })
  } else {
    allReceiveDialogVisible.value = false
  }
}

const initData = () => {
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  initData()
}

const queryParam = {
  raffleId: routeParam.query.id,
  uuid: routeParam.query.uuid
}
const statistical = ref({
  grantAmount: 0,
  receivedAmount: 0,
  surplusNum: 0,
  participateNum: 0
})
const getStatistics = async () => {
  if (routeParam.query.id != undefined) {
    await queryStatistical('/main/raffleManage/raffleStatistics', {
      id: routeParam.query.id,
      uuid: routeParam.query.uuid
    }).then((item) => {
      statistical.value = item
    })
  }
}
getStatistics()

const searchCb = () => {
  getStatistics()
  return queryParam
}

const resetCb = () => {
  getStatistics()
  return queryParam
}

const [
  pageContentRef,
  handleResetClick,
  handleSearchClick,
  handleDownBtnClick
] = usePageSearch(resetCb, searchCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _createTextVNode("总金额: "),
        _createElementVNode("em", null, _toDisplayString(statistical.value.grantAmount) + " 元，", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("中奖金额: "),
        _createElementVNode("em", null, _toDisplayString(statistical.value.receivedAmount) + " 元，", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("剩余金额: "),
        _createElementVNode("em", null, _toDisplayString(statistical.value.grantAmount - statistical.value.receivedAmount) + " 元，", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("剩余红包: "),
        _createElementVNode("em", null, _toDisplayString(statistical.value.surplusNum) + " 个，", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("抽奖次数: "),
        _createElementVNode("em", null, _toDisplayString(statistical.value.participateNum) + " 次", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("参与人数: "),
        _createElementVNode("em", null, _toDisplayString(statistical.value.participatePersonNum) + " 人", 1)
      ])
    ]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "raffleRecord",
      onSortChange: handleSortChange,
      downFilename: "中奖记录.xlsx",
      onReceiveAll: changeAllReceiveStatus,
      onDownBtnClick: _unref(handleDownBtnClick)
    }, {
      status: _withCtx((scope) => [
        (scope.row.receiveStatus === 0)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              size: "mini",
              type: "primary",
              onClick: ($event: any) => (changeReceiveStatus(scope.row))
            }, {
              default: _withCtx(() => [
                _createTextVNode("领取 ")
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : (scope.row.receiveStatus === 1)
            ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 1,
                size: "mini",
                type: "success"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("已领取")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onDownBtnClick"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_dialog, {
        modelValue: receiveDialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((receiveDialogVisible).value = $event)),
        title: "奖励领取",
        width: "30%",
        "destroy-on-close": "",
        center: ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleReceive(false)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (handleReceive(true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("确认")
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_dialog, {
        modelValue: allReceiveDialogVisible.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((allReceiveDialogVisible).value = $event)),
        title: "奖励领取",
        width: "30%",
        "destroy-on-close": "",
        center: ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (handleAllReceive(false)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (handleAllReceive(true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("确认")
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})